// import isCurrentLanguageRu from "./current-language"
//
// $(document).ready(function() {
//
//     const $langBtn = $(".js-lang-btn");
//
//     $langBtn.removeClass("active");
//
//     if(isCurrentLanguageRu()) {
//
//         $langBtn.filter(".rus").addClass("active");
//     }else{
//
//         $langBtn.filter(".en").addClass("active");
//     }
// });
